// import authSlice from './features/authSlice';
import loadingSlice from "./features/loadingSlice";
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./features/authSlice";
import mapSlice from "./features/mapSlice";
import overallSummarySlice from "./features/overallSummarySlice";
import workforceSlice from "./features/workforceSlice";
import systemAnalysisSlice from "./features/systemAnalysisSlice";

const reducer = combineReducers({
  Loading: loadingSlice,
  Auth: authSlice,
  Map: mapSlice,
  OverallSummary: overallSummarySlice,
  Workforce: workforceSlice,
  SystemAnalysis: systemAnalysisSlice,
});

export const store = configureStore({
  reducer,
});
